import TextField from '@Fields/TextField';
import SelectField from '@Fields/SelectField';
import AutoCompleteField from '@Fields/AutoCompleteField';
import RadioField from '@Fields/RadioField';
import CheckBoxListField from '@Fields/CheckBoxListField';

//  Modal will be instantiated with empty values. To pass in values, whoever call this component needs to pass in a modalObject and name its prop 'model'
//          modalObject = {
//              SerialVinResults,
//              ShowModal: Props.model.ShowModal,
//          }

class ModalSerialVinSpecsForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleButtonClick.bind(this);
        this.state = ModalSwitchSpecUnitsForm.modelToState(props);
    }

    static modelToState(props) {
        return {
            SerialVinResults: null,
            ShowModal: false,
            specsViewModel: null,
        };
    }

    componentWillReceiveProps(Props) {
        if (Props.model != null) {
            this.setState({
                SerialVinResults: Props.model.SerialVinResults,
                ShowModal: Props.model.ShowModal,
                specsViewModel: Props.specsViewModel,
            });
        }
        else {
            this.setState({
                SerialVinResults: null,
                ShowModal: false,
                specsViewModel: null,
            });
        }
    }

    handleButtonClick(field, value) {
        var state = this.state;

        state[field] = value

        this.setState(state)
    }

    ChangeSpecValueToSerialVINSpecValue() {

        // Get SerialVinResults.FormInputs and set them into the SpecsViewModel
        var allSpecPromises = [];
        var parentModel = this.props.parentModel;
        var st = this.state;
        var props = this.props;
        for (let index in this.state.SerialVinResults.FormInputs) {
            //the inner logic is live, but this promise function is new
            var pSpecValueUpdating = new Promise(function (resolve, reject) {
                var matchingSpecsModalIdx = st.SerialVinResults.oSpecsModal.findIndex(function (modalItm) { return modalItm.Label == index });
                var matchingSpecsModal = (matchingSpecsModalIdx == -1 ? null : st.SerialVinResults.oSpecsModal[matchingSpecsModalIdx]);
                var formInputModel = st.specsViewModel.FormInputs[index];
                var serialVinLookupModel = st.SerialVinResults.FormInputs[index];
                //if the form value doesn't match the lookup results value, and the lookup results aren't empty or null
                if (formInputModel.Value != serialVinLookupModel.Value && serialVinLookupModel.Value != "" && serialVinLookupModel.Value != null) {
                    var availableDynamicSpecValues = [];
                    //go through each of the groups of specs
                    for (var x = 0; x < st.specsViewModel.oMMMCategoryGroupSpecs.length; x++) {
                        var groupSpecs = st.specsViewModel.oMMMCategoryGroupSpecs[x];
                        var oSpecSearch = groupSpecs.Specs.filter(function (spc) {
                            return spc.SpecField == index;
                        });
                        //if we find the spec we wanted in this group
                        if (oSpecSearch.length > 0) {
                            var oSpec = oSpecSearch[0];
                            var options = [];
                            //get all the input options for the given spec
                            if (oSpec.InputControlListOptions) {
                                for (var i = 0; i < oSpec.InputControlListOptions.length; i++) {
                                    var oOption = oSpec.InputControlListOptions[i];
                                    options.push(oOption.Value);
                                }
                                if (options.length > 0) {
                                    availableDynamicSpecValues = options;
                                }
                            }
                        }
                    }
                    //if we have available options, make sure the value we want to insert is in the list
                    if (availableDynamicSpecValues.length > 0) {
                        var indexOfVal = availableDynamicSpecValues.findIndex(function (dsv) {
                            return dsv.toLowerCase() == serialVinLookupModel.Value.toLowerCase();
                        });
                        //only set this value if it's also an option in the list
                        if (indexOfVal != -1) {
                            parentModel.specsViewModel.FormInputs[index].Value = availableDynamicSpecValues[indexOfVal];
                        }
                        resolve();
                        //if we don't have a list of options to filter though, assume the value is valid
                    }
                    else {
                        var specsDependentOnThisSpecIdx = parentModel.specsViewModel.DependentAutoComplete.findIndex(function (ac) {
                            return ac.DependentSpecName == index;
                        });
                        //if we find any specs that are dependent on this spec, add in the value to the source and enable them
                        if (specsDependentOnThisSpecIdx != -1) {
                            parentModel.specsViewModel.DependentAutoComplete[specsDependentOnThisSpecIdx].Source.push(st.SerialVinResults.FormInputs[index].Value);
                            parentModel.specsViewModel.DependentAutoComplete[specsDependentOnThisSpecIdx].Disabled = false;
                        }
                        //find the index of any dynamic AC's that have a Dependency on this spec
                        var idxOfDependentAC = parentModel.specsViewModel.oDynamicAutoComplete.findIndex(function (dAC) {
                            //this part is why I needed the SpecsViewModel updated to have the SpecID w/ it
                            return dAC.Dependencies[parseInt(matchingSpecsModal.DefinedSpecID)] != undefined;
                        });
                        //if we have a dynamic spec that is dependent on this spec, fill in this spec's value for the Dependency field
                        if (idxOfDependentAC != -1) {
                            parentModel.specsViewModel.oDynamicAutoComplete[idxOfDependentAC].Dependencies[parseInt(matchingSpecsModal.DefinedSpecID)] = st.SerialVinResults.FormInputs[index].Value.toUpperCase();
                        }
                        //now fill in the main spec value w/ the retrieved value
                        parentModel.specsViewModel.FormInputs[index].Value = st.SerialVinResults.FormInputs[index].Value.toUpperCase();
                        resolve();
                    }
                }
                else {
                    resolve();
                }
            });
            allSpecPromises.push(pSpecValueUpdating);
        }

        //once all these have resolved, run our saving functions
        //the promise wrapper around this is new, but will ensure all the functions above are completed first
        Promise.all(allSpecPromises).then(function () {
            parentModel.modalObject = null;
            parentModel.bAllowModalToShow = false;
            props.handleFormUpdate(parentModel);
            props.UpdateSpecsViewModel(parentModel.specsViewModel);
            props.SaveSpecsToXML(parentModel.specsViewModel);
            //call our default specs function now that we have all our SerialVIN values transpiled in
            //this property is NOT rolled to live yet
            if (props.getDefaultSpecs) {
                props.getDefaultSpecs(parentModel);
            }
            //this calls the javascript close in the SinglePageUI.js
            CloseModal();
        });
    }

    CloseModal() {
        var parentModel = this.props.parentModel;
        parentModel.modalObject = null;
        parentModel.bAllowModalToShow = false;

        this.props.handleFormUpdate(parentModel);

        //this calls the javascript close in the SinglePageUI.js
        CloseModal();
    }

    render() {
        //parse specs and serialVin Specs
        var key = 0;
        var addtlGroups = [];
        if (this.state.SerialVinResults != null) {
            for (let groupIndex in this.state.SerialVinResults.oMMMCategoryGroupSpecs) {
                var oMMMCategoryGroupSpecPage = this.state.SerialVinResults.oMMMCategoryGroupSpecs[groupIndex];

                //Additional Specs
                var addtlSpecs = [];

                //specs for this category
                var addtlSpecIndex = 0;
                for (var specIndex = 0; specIndex < oMMMCategoryGroupSpecPage.Specs.length; specIndex++) {
                    let spec = oMMMCategoryGroupSpecPage.Specs[specIndex];

                    //check if spec in SpecsViewModel is different than SerialVin
                    if (this.state.SerialVinResults.FormInputs[spec.SpecField].Value != null && this.state.SerialVinResults.FormInputs[spec.SpecField].Value != "" && this.state.specsViewModel.FormInputs[spec.SpecField].Value != null && this.state.specsViewModel.FormInputs[spec.SpecField].Value != this.state.SerialVinResults.FormInputs[spec.SpecField].Value) {
                        let bIsMileageHourSpec = false;
                        if (this.state.specsViewModel.GroupIndex != -1 && spec == this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex])
                            bIsMileageHourSpec = true;

                        if (!spec.Required && spec.SpecInputControlType != "CustomControl" && !bIsMileageHourSpec) {
                            //every two specs we want to add a clear
                            if (addtlSpecIndex != 0 && (addtlSpecIndex % 2) == 0) {
                                addtlSpecs.push(
                                    <div className="clear" key={key}></div>
                                );
                                key = key + 1;
                            }
                            addtlSpecIndex = addtlSpecIndex + 1;

                            switch (spec.SpecInputControlType) {
                                case "MultiLineTextBox":
                                    addtlSpecs.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key} style={{ width: "98%" }}>
                                            <TextField
                                                type="textarea"
                                                disabled={true}
                                                feRequired={spec.RecommendedForEvaluation}
                                                onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                id={spec.SpecField}
                                                label={spec.Label}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                            />
                                        </div>
                                    );
                                    break;
                                case "CheckBox":
                                    if (this.state.SerialVinResults.FormInputs[spec.SpecField].Value == "") {
                                        this.state.SerialVinResults.FormInputs[spec.SpecField].Value = "0";
                                    }
                                    addtlSpecs.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key} style={{ marginTop: "15px" }}>
                                            <TextField
                                                inline={true}
                                                type="checkbox"
                                                disabled={true}
                                                YesNo={spec.IsYesNo}
                                                isSpec={true}
                                                feRequired={spec.RecommendedForEvaluation}
                                                id={spec.SpecField}
                                                label={spec.Label}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                            />
                                        </div>
                                    );
                                    break;
                                case "TextBox":
                                    if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {

                                        let selectID = spec.SpecField + "unit#";

                                        var selectvalues = [];

                                        for (let a = 0; a < spec.MeasurementUnitOptions.length; a++) {
                                            for (let b = 0; b < this.state.specsViewModel.oMMMMeasurementUnit.length; b++) {
                                                if (spec.MeasurementUnitOptions[a] == this.state.specsViewModel.oMMMMeasurementUnit[b].MeasurementUnitID) {
                                                    selectvalues.push({ text: this.state.specsViewModel.oMMMMeasurementUnit[b].Symbol, value: this.state.specsViewModel.oMMMMeasurementUnit[b].Unit })
                                                    break;
                                                }
                                            }
                                        }

                                        if (this.state.specsViewModel.FormInputs[selectID].Value == "foot") {
                                            let inchfield = spec.SpecField + "inch#";
                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                    <TextField
                                                        type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                        min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        disabled={true}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                        id={spec.SpecField}
                                                        isRequired={spec.Required}
                                                        label={spec.Label}
                                                        value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                        SmallInput={true}
                                                        className={"footSpecText"}
                                                        mileageinch={true}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    />
                                                    <SelectField
                                                        id={selectID}
                                                        value={this.state.SerialVinResults.FormInputs[selectID].Value}
                                                        SmallSelect={true}
                                                        className={"v-small-select"}
                                                        values={selectvalues}
                                                        disabled={true}
                                                        mileageinch={true}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                        bShowFullName={true}
                                                        hasLabel={true}
                                                        ariaLabelledBy={spec.SpecField + "label"}
                                                    />
                                                    <TextField
                                                        type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                        min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        disabled={true}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                        id={inchfield}
                                                        SmallInput={true}
                                                        className={"inchSpecText"}
                                                        isRequired={spec.Required}
                                                        value={this.state.SerialVinResults.FormInputs[inchfield].Value}
                                                        mileageinchsecond={true}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(inchfield, e); }}
                                                    />
                                                    <label htmlFor={inchfield}> in.</label>
                                                </div>
                                            );
                                        }
                                        else {
                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                    <TextField
                                                        type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                        min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        disabled={true}
                                                        AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                        id={spec.SpecField}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        isRequired={spec.Required}
                                                        SmallInput={true}
                                                        label={spec.Label}
                                                        value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                        mileage={true}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    />
                                                    <SelectField
                                                        id={selectID}
                                                        value={this.state.SerialVinResults.FormInputs[selectID].Value}
                                                        SmallSelect={true}
                                                        values={selectvalues}
                                                        disabled={true}
                                                        mileage={true}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                        bShowFullName={true}
                                                        hasLabel={true}
                                                        ariaLabelledBy={spec.SpecField + "label"}
                                                    />
                                                </div>
                                            );
                                        }
                                    }
                                    else {
                                        addtlSpecs.push(
                                            <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                <TextField
                                                    type={spec.SpecDataFormat == 'Number' ? 'number' : null}
                                                    min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    disabled={true}
                                                    AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                    id={spec.SpecField}
                                                    isRequired={spec.Required}
                                                    label={spec.Label}
                                                    value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                />
                                            </div>
                                        );
                                    }
                                    break;
                                case "AutoComplete":
                                    if (spec.UsesDynamicSource == true) {
                                        if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                            for (var a = 0; a < this.state.specsViewModel.oDynamicAutoComplete.length; a++) {
                                                if (this.state.specsViewModel.oDynamicAutoComplete[a].DefinedSpecID == spec.DefinedSpecID) {
                                                    for (var y = 0; y < this.state.specsViewModel.DependentAutoComplete.length; y++) {
                                                        if (this.state.specsViewModel.DependentAutoComplete[y].SpecField == spec.SpecField) {
                                                            addtlSpecs.push(
                                                                <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                                    <AutoCompleteField
                                                                        feRequired={spec.RecommendedForEvaluation}
                                                                        FromList={true}
                                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                        isRequired={spec.Required}
                                                                        disabled={this.state.specsViewModel.DependentAutoComplete[y].Disabled}
                                                                        id={spec.SpecField}
                                                                        label={spec.Label}
                                                                        value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                                        values={this.state.specsViewModel.DependentAutoComplete[y].Source}
                                                                        onFieldChanged={(value) => { this.handleFieldChanged(spec.SpecField, value); }}
                                                                    />
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            for (var a = 0; a < this.state.specsViewModel.oDynamicAutoComplete.length; a++) {
                                                if (this.state.specsViewModel.oDynamicAutoComplete[a].DefinedSpecID == spec.DefinedSpecID) {
                                                    addtlSpecs.push(
                                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                            <AutoCompleteField
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                FromList={true}
                                                                disabled={true}
                                                                id={spec.SpecField}
                                                                onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                isRequired={spec.Required}
                                                                label={spec.Label}
                                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                                values={this.state.specsViewModel.oDynamicAutoComplete[a].Source}
                                                                onFieldChanged={(value) => { this.handleFieldChanged(spec.SpecField, value); }}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        var autocompletes = [];
                                        for (var b = 0; b < spec.InputControlListOptions.length; b++) {
                                            autocompletes.push(spec.InputControlListOptions[b].Text.toUpperCase());
                                        }
                                        addtlSpecs.push(
                                            <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                <AutoCompleteField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    isRequired={spec.Required}
                                                    disabled={true}
                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                    id={spec.SpecField}
                                                    label={spec.Label}
                                                    value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value.toUpperCase()}
                                                    values={autocompletes}
                                                    onFieldChanged={(value) => { this.handleFieldChanged(spec.SpecField, value); }}
                                                />
                                            </div>
                                        );
                                    }
                                    break;
                                case "RadioButtonList":
                                    let radios = [];
                                    for (var c = 0; c < spec.InputControlListOptions.length; c++) {
                                        radios.push({ text: spec.InputControlListOptions[c].Text.toUpperCase(), value: spec.InputControlListOptions[c].Value.toUpperCase() })
                                    }

                                    addtlSpecs.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                            <RadioField
                                                feRequired={false}
                                                id={spec.SpecField}
                                                disabled={true}
                                                radios={radios}
                                                label={spec.Label}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value.toUpperCase()}
                                                isvertical={false}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                            />
                                        </div>
                                    );
                                    break;
                                case "DropDownList":

                                    if (spec.UsesDynamicSource == true) {
                                        if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                            for (var a = 0; a < this.state.specsViewModel.oDynamicDropDown.length; a++) {
                                                if (this.state.specsViewModel.oDynamicDropDown[a].DefinedSpecID == spec.DefinedSpecID) {
                                                    for (var y = 0; y < this.state.specsViewModel.DependentDropDowns.length; y++) {
                                                        if (this.state.specsViewModel.DependentDropDowns[y].SpecField == spec.SpecField) {
                                                            addtlSpecs.push(
                                                                <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                                    <SelectField
                                                                        feRequired={spec.RecommendedForEvaluation}
                                                                        isRequired={spec.Required}
                                                                        disabled={this.state.specsViewModel.DependentDropDowns[y].Disabled}
                                                                        id={spec.SpecField}
                                                                        className={"spec-select"}
                                                                        placeholder={spec.Label}
                                                                        value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                                        values={this.state.specsViewModel.DependentDropDowns[y].DropDownOptions}
                                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                        bShowFullName={true}
                                                                    />
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            for (var a = 0; a < this.state.specsViewModel.oDynamicDropDown.length; a++) {
                                                if (this.state.specsViewModel.oDynamicDropDown[a].DefinedSpecID == spec.DefinedSpecID) {
                                                    addtlSpecs.push(
                                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                            <SelectField
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                isRequired={spec.Required}
                                                                id={spec.SpecField}
                                                                disabled={true}
                                                                className={"spec-select"}
                                                                placeholder={spec.Label}
                                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                                values={this.state.specsViewModel.DependentDropDowns[y].DropDownOptions}
                                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        let options = [];
                                        for (var b = 0; b < spec.InputControlListOptions.length; b++) {
                                            options.push({ text: spec.InputControlListOptions[b].Text.toUpperCase(), value: spec.InputControlListOptions[b].Value.toUpperCase() });
                                        }

                                        addtlSpecs.push(
                                            <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                                <SelectField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    isRequired={spec.Required}
                                                    id={spec.SpecField}
                                                    className={"spec-select"}
                                                    disabled={true}
                                                    placeholder={spec.Label}
                                                    value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value.toUpperCase()}
                                                    values={options}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    bShowFullName={true}
                                                />
                                            </div>
                                        );
                                    }
                                    break;
                                case "CheckBoxList":
                                    let checkboxesEven = [];
                                    let checkboxesOdd = [];
                                    let checkboxes = [];
                                    for (var c = 0; c < spec.InputControlListOptions.length; c++) {
                                        if (c % 2 == 0) {
                                            checkboxesEven.push({ text: spec.InputControlListOptions[c].Text.toUpperCase(), value: spec.InputControlListOptions[c].Value.toUpperCase() });
                                        }
                                        else {
                                            checkboxesOdd.push({ text: spec.InputControlListOptions[c].Text.toUpperCase(), value: spec.InputControlListOptions[c].Value.toUpperCase() });
                                        }
                                    }

                                    checkboxes.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                            <CheckBoxListField
                                                feRequired={spec.RecommendedForEvaluation}
                                                id={spec.SpecField}
                                                disabled={true}
                                                checkboxes={checkboxesEven}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value.toUpperCase()}
                                                isvertical={false}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                            />
                                        </div>
                                    );

                                    key = key + 1;

                                    checkboxes.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                            <CheckBoxListField
                                                feRequired={spec.RecommendedForEvaluation}
                                                id={spec.SpecField}
                                                disabled={true}
                                                checkboxes={checkboxesOdd}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value.toUpperCase()}
                                                isvertical={false}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                            />
                                        </div>
                                    );

                                    addtlSpecs.push(
                                        <div className="spec-checkboxList" label={spec.Label}>
                                            {checkboxes}
                                        </div>
                                    );

                                    break;
                                case "DatePicker":
                                    addtlSpecs.push(
                                        <div className="column6 left" id={spec.SpecField + "column"} key={key}>
                                            <label id={spec.SpecField + "DateLabel"} htmlFor={spec.SpecField}>{spec.Label} {"\n"}</label>
                                            <TextField
                                                feRequired={spec.RecommendedForEvaluation}
                                                disabled={true}
                                                AddCommas={spec.SpecDataFormat == "Number" ? true : false}
                                                onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                id={spec.SpecField}
                                                isRequired={spec.Required}
                                                value={this.state.SerialVinResults.FormInputs[spec.SpecField].Value}
                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                hasLabel={true}
                                                ariaLabelledBy={spec.SpecField + "DateLabel"}
                                            />
                                            {/*Hidden field needed to dispatch an event in jquery and land here in React*/}
                                            <div style={{ display: 'none' }}>
                                                <TextField
                                                    id={spec.SpecField + "DateSelected"}
                                                    disabled={true}
                                                    value={this.state.specsViewModel.HeadCount}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField + "DateSelected", e); }}
                                                    hasLabel={true}
                                                    ariaLabelledBy={spec.SpecField + "DateLabel"}
                                                />
                                            </div>
                                        </div>
                                    );

                                    if (typeof jQuery === 'undefined') {
                                        // jQuery is NOT available
                                    }
                                    else {
                                        $('#' + spec.SpecField).Datepicker()
                                    }

                                    break;
                            }
                        }

                        key = key + 1;
                    }
                }

                //add the specs to an accordion group
                if (addtlSpecs.length > 0) {
                    var addtlSpecsClassName = "addtlSpecs-content-" + groupIndex;
                    addtlGroups.push(
                        <div key={key}>
                            <strong style={{ fontSize: '18px' }}>{oMMMCategoryGroupSpecPage.GroupName}</strong>
                            <div>
                                {addtlSpecs}
                            </div>
                            <div className="clear" key={key}><br /></div>
                        </div>
                    );
                    key = key + 1;
                }
            }
        }

        var style = {};
        if (this.state.ShowModal && addtlGroups.length > 0)
            style.display = 'block';
        else
            style.display = 'none';

        var basedOnText = "";
        if (this.props.parentModel.EquipmentIdentifier.toUpperCase() == "VIN")
            basedOnText = this.props.parentModel.Translations["BasedOnVIN"];
        else
            basedOnText = this.props.parentModel.Translations["BasedOnSerial"];

        return (
            <div className="modal" id="unit-switch-modal-SNVIN" style={style} key="ModalSerialVIN">
                <div className="modal-content">
                    <div className="modal-head">
                        <h2>{this.props.parentModel.EquipmentIdentifier} Specs</h2>
                        <span className="close" onClick={(e) => { this.CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                    <div className="modal-main">
                        {basedOnText}
                        <div className="clear" key={key}><br /></div>
                        <div className="modal-main-scrollable">
                            {addtlGroups}
                        </div>
                    </div>
                    <div className="modal-buttons cf">
                        <button role="link" className="save-modal PrimaryBGC siteFontColor" onClick={(e) => { this.ChangeSpecValueToSerialVINSpecValue(); }} >{this.props.parentModel.Translations["Continue"]}</button>
                        <button role="link" className="cancel-modal" onClick={(e) => { this.CloseModal(); }}>{this.props.parentModel.Translations["NoThanks"]}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalSerialVinSpecsForm;
global.ModalSerialVinSpecsForm = ModalSerialVinSpecsForm;